/**
 * 住院管家
 */

export default [
  /**
   * 选择医院、就诊人
   */
  {
    path: '/ncp/select',
    component: () => import('../page/ncp/select')
  },
  /**
   * 问卷
   */
  {
    path: '/ncp/paper',
    component: () => import('../page/ncp/paper')
  },
  /**
   * 项目选择
   */
  {
    path: '/ncp/items',
    component: () => import('../page/ncp/items')
  },
  /**
   * 订单确认
   */
  {
    path: '/ncp/confirm',
    component: () => import('../page/ncp/confirm')
  },
  /**
   * 我的订单-详情
   */
  {
    path: '/ncp/order/detail',
    component: () => import('../page/ncp/order/detail')
  },
  /**
   * 我的开单-列表
   */
  {
    path: '/ncp/order/list',
    component: () => import('../page/ncp/order/list')
  }
]



// WEBPACK FOOTER //
// ./src/router/ncp.js